import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_container = _resolveComponent("loading-container")!

  return (_openBlock(), _createBlock(_component_loading_container, {
    state: _ctx.state,
    errormsg: "Beim Laden ist ein Fehler aufgetreten."
  }, {
    default: _withCtx(() => [
      (_ctx.currentSiteInLinklist)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleLinklisteLink())),
            class: _normalizeClass(["btn btn-icon btn-icon-extend text-primary mw-0 px-2 mw-0 btn-star", { 'mlactive': _ctx.currentSiteInLinklist, '': !_ctx.currentSiteInLinklist }]),
            type: "button"
          }, [...(_cache[2] || (_cache[2] = [
            _createTextVNode(" Gemerkt ", -1),
            _createElementVNode("i", { class: "fa-regular fa-star" }, null, -1),
            _createElementVNode("span", { class: "sr-only" }, "Seite von der Merkliste entfernen", -1)
          ]))], 2))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleLinklisteLink())),
            class: _normalizeClass(["btn btn-icon btn-icon-extend text-primary mw-0 px-2 mw-0 btn-star", { 'mlactive': _ctx.currentSiteInLinklist, '': !_ctx.currentSiteInLinklist }]),
            type: "button"
          }, [...(_cache[3] || (_cache[3] = [
            _createTextVNode(" Merken ", -1),
            _createElementVNode("i", { class: "fa-regular fa-star" }, null, -1),
            _createElementVNode("span", { class: "sr-only" }, "Seite zur Merkliste hinzufügen", -1)
          ]))], 2))
    ]),
    _: 1
  }, 8, ["state"]))
}